<template lang="pug">
    #card-analise-socioambiental-operacao
        BaseHeader(
            :titulo="$t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.titulo')",
            voltarPara="emit"
            @voltarClicado="fechar()"
            :exibeBotao='false'
        )
    
        section.card-analise-socioambiental-operacao__body
            div(
                v-for='(diagnosticoProtocolo, index) in diagnosticosProtocolo',
                :key='index',
                @click='abrirModalResultado(diagnosticoProtocolo)'
            )
                .card-analise-socioambiental-operacao__body__item(
                    :class='statusClasses(diagnosticoProtocolo.status)'
                )
                    .d-wrap.align-content-stretch
                        .d-flex.align-items-center
                            i.card-analise-socioambiental-operacao__body__item__icone(
                                :class='statusIcones(diagnosticoProtocolo.status)'
                            )
                            .font-weight-bold {{ $t(`mensagens.operacao.monitoramento.${diagnosticoProtocolo.codigo}`) }}: {{ diagnosticoProtocolo.nome }}
    
                        .car-vinculado.font-weight-bold(v-if='diagnosticoProtocolo.carsVinculadosTerritorio') {{ $t('mensagens.operacao.car') }}: {{ diagnosticoProtocolo.carsVinculadosTerritorio }}
    
                    i.el-icon-arrow-right.el-icon--right.card-analise-socioambiental-operacao__body__item--acao
    
        section.card-analise-socioambiental-operacao__aprovar-recusar(
            v-if='habilitarAnalise'
        )
            h2 {{ $t('mensagens.comuns.situacao') }}
    
            el-form(label-position='top', size='small')
                el-form-item.mt-2
                    el-radio-group(v-model='escolhaAprovarReprovar')
                        el-radio.mr-4(:label="$t('mensagens.operacao.acoes.aprovar')")
                        el-radio(:label="$t('mensagens.operacao.acoes.reprovar')")
    
                el-form-item.mt-1(v-if='opcaoReprovarAtiva')
                    div(slot='label' style='display: grid')
                        span.campo_obrigatorio {{ $t('mensagens.operacao.motivo') }}
    
                        el-select(
                            v-model='motivosReprovacaoSelecao',
                            multiple,
                            clearable
                        )
                            el-option(
                                v-for='{ nome, id } in motivosReprovacao',
                                :key='nome',
                                :label='nome',
                                :value='id'
                            )
    
                el-form-item
                    div(slot='label')
                        span(v-if='opcaoReprovarAtiva', style='color: red') *
                        span {{ $t('mensagens.operacao.justificativa') }}
    
                        el-tooltip(
                            v-if='opcaoReprovarAtiva',
                            :content="$t('mensagens.operacao.cadastrarEditarOperacao.analiseProtocoloSocio.textoJustificativa')",
                            placement='right',
                            effect='light'
                        )
                            i.mdi.mdi-information-outline.ml-2
    
                    el-input(
                        v-model='justificativaAprovarReprovar',
                        :maxlength='255',
                        :placeholder="$t('mensagens.operacao.justificativa')",
                        type='textarea',
                        resize='none',
                        :rows='2'
                    )
    
        section.card-analise-socioambiental-operacao__acao(v-if='habilitarAnalise')
            BaseButton.mr-2(size='small', @click='fechar()')
                | {{ $t('mensagens.comuns.voltar') }}
    
            BaseButton(
                @click='aprovarRecusarOperacao()',
                :disabled='!habilitarFinalizarAnalise',
                type='primary',
                size='small'
            )
                | {{ $t('mensagens.operacao.acoes.finalizarAnalise') }}
    
        section.card-analise-socioambiental-operacao__acao(v-else)
            BaseButton(size='small', @click='fechar()')
                | {{ $t('mensagens.comuns.voltar') }}
    
            BaseButton(
                v-if='habilitarBotaoCadastrar',
                @click='cadastrarOperacao()',
                type='primary',
                size='small'
            )
                | {{ editandoOperacao ? $t('mensagens.comuns.salvar') : $t('mensagens.operacao.acoes.cadastrarOperacao') }}
    
        ModalResultadoDiagnostico(ref='modalResultadoDiagnostico')
    
        ModalConfirmarAprovacao(
            :mostrar='mostrarModalConfirmarAprovacao'
            @confirmar='confirmarAprovacao'
            @fechar='mostrarModalConfirmarAprovacao = false'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ModalResultadoDiagnostico from '@/components/operacao/gestao/ModalResultadoDiagnostico.vue';
import OperacaoService from '@/services/OperacaoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import { calcularBuffer } from '@/utils/calcularBuffer.js';
import ModalConfirmarAprovacao from '@/components/operacao/gestao/ModalConfirmarAprovacao.vue';

export default {
    name: 'CardAnaliseSocioambientalOperacao',
    components: {
        BaseHeader,
        ModalResultadoDiagnostico,
        BaseButton,
        ModalConfirmarAprovacao
    },
    emits: [
        'aprovarOperacao',
        'reprovarOperacao',
        'fechar',
        'cadastrarOperacao'
    ],

    props: {
        dadosDiagnostico: {
            type: Object,
            required: true
        },
        editandoOperacao: {
            type: Boolean,
            required: false,
            default: false
        },
        habilitarBotaoCadastrar: {
            type: Boolean,
            required: false,
            default: true
        },
        habilitarAnalise: {
            type: Boolean,
            required: false,
            default: false
        },
        statusAnalise: {
            type: String,
            required: false,
            default: ''
        }
    },

    computed: {
        opcaoReprovarAtiva() {
            return (this.escolhaAprovarReprovar === this.$t('mensagens.operacao.acoes.reprovar'));
        }
    },

    data() {
        return {
            diagnosticosProtocolo: [],
            escolhaAprovarReprovar: this.$t('mensagens.operacao.acoes.aprovar'),
            justificativaAprovarReprovar: null,
            mostrarDialogCamadas: false,
            mostrarCardAprovarReprovar: false,
            motivosReprovacao: [],
            motivosReprovacaoSelecao: [],
            territorios: [],
            diagnosticoPessoa: false,
            mostrarModalConfirmarAprovacao: false,
            habilitarFinalizarAnalise: false,
            status: {
                ALERTA: {
                    classeIcone: 'alerta flow flow-warning-sign'
                },
                SUCESSO: {
                    classeIcone: 'sucesso el-icon-circle-check'
                },
                ATENCAO: {
                    classeIcone: 'atencao flow flow-warning-sign'
                }
            }
        };
    },

    async mounted() {
        await this.realizarDiagnosticoListagem();
        await this.buscarMotivosReprovacao();
    },

    methods: {
        statusClasses(status) {
            return this.status[status] ? this.status[status].classeCollapse : '';
        },

        statusIcones(status) {
            return this.status[status] ? this.status[status].classeIcone : '';
        },

        async aprovarRecusarOperacao() {
            const payload = {
                justificativa: this.justificativaAprovarReprovar,
                motivos: this.motivosReprovacaoSelecao
            };

            if (this.escolhaAprovarReprovar === this.$t('mensagens.operacao.acoes.reprovar')) {
                if (!this.justificativaAprovarReprovar || this.justificativaAprovarReprovar.length === 0) {
                    this.$notify.warning({
                        message: this.$t('mensagens.operacao.notificacao.preenchaJustificativa')
                    });
                    return;
                }

                if (this.motivosReprovacaoSelecao.length === 0) {
                    this.$notify.warning({
                        message: this.$t('mensagens.operacao.notificacao.motivoReprovacao')
                    });
                    return;
                }

                this.$emit('reprovarOperacao', payload);
            } else {
                if (this.contemAlertaOuAtencao()) {
                    this.mostrarModalConfirmarAprovacao = true;
                } else {
                    this.$emit('aprovarOperacao', payload);
                }
            }
        },

        confirmarAprovacao() {
            const payload = {
                justificativa: this.justificativaAprovarReprovar,
                motivos: this.motivosReprovacaoSelecao
            };
            if (this.editandoOperacao) {
                this.$emit('cadastrarOperacao');
            } else {
                this.$emit('aprovarOperacao', payload);
            }
        },

        contemAlertaOuAtencao() {
            return this.diagnosticosProtocolo.some(item => item.status === 'ALERTA' || item.status === 'ATENCAO');
        },

        async buscarMotivosReprovacao() {
            await OperacaoService.buscarMotivosReprovacao()
                .then(({ data }) => {
                    this.motivosReprovacao = data.itens;
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.erroMotivoReprovacao')
                    });
                });
        },

        cadastrarOperacao() {
            if (this.editandoOperacao) {
                if (this.contemAlertaOuAtencao() && this.statusAnalise && this.statusAnalise === 'APROVADO') {
                    this.mostrarModalConfirmarAprovacao = true;
                } else {
                    this.$emit('cadastrarOperacao');
                }
            } else {
                this.$emit('cadastrarOperacao');
            }
        },

        abrirModalResultado(diagnosticoProtocolo) {
            
            switch (diagnosticoProtocolo.codigo) {
                case 'TERRITORIO':
                    OperacaoService.preAnaliseTerritorio(
                        {
                            protocolo: diagnosticoProtocolo.protocolo,
                            idTerritorio: diagnosticoProtocolo.identificador
                        })
                    .then(({data}) => {
                        data.grupo.map(item => {
                            if (item.codigo === 'PROXIMIDADE_TERRITORIO_ANALISADO' || item.codigo === 'PROXIMIDADE_CAR_ANALISADO') {
                                let geometria;
                                if (item.codigo === 'PROXIMIDADE_TERRITORIO_ANALISADO') {
                                    geometria = data.territorioGeometria;
                                } else {
                                    geometria = item.informacoesGerais?.geometria;
                                }
                                
                                item.diagnostico.forEach(diagnostico => {
                                    diagnostico.geometriaProximidade = calcularBuffer(geometria, diagnostico.bufferMetros);
                                });
                            }

                            if (item.codigo === 'CAR_ANALISADO' || item.codigo === 'PROXIMIDADE_CAR_ANALISADO') {
                                item.geometriaDoCar = item.informacoesGerais?.geometria;
                            }
                        });
                        this.$refs.modalResultadoDiagnostico.abrirModal(data);
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t('mensagens.operacao.notificacao.erroProtocoloSocio')
                        });
                    });
                    break;
                
                case 'GLEBA':
                    OperacaoService.preAnaliseGleba(
                        {
                            protocolo: diagnosticoProtocolo.protocolo,
                            idTerritorio: diagnosticoProtocolo.idTerritorio,
                            nomeGleba: diagnosticoProtocolo.nome,
                            glebaGeometria: diagnosticoProtocolo.glebaGeometria,
                            utilizouAreaTotalTerritorio: diagnosticoProtocolo.utilizouAreaTotalTerritorio
                        })
                    .then(({data}) => {
                        data.grupo.map(item => {
                            if (item.codigo === 'PROXIMIDADE_GLEBA_ANALISADA') {
                                item.diagnostico.forEach(diagnostico => {
                                    diagnostico.geometriaProximidade = calcularBuffer(data.glebaGeometria, diagnostico.bufferMetros);
                                });
                            }
                        });
                        this.$refs.modalResultadoDiagnostico.abrirModal(data);
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t('mensagens.operacao.notificacao.erroProtocoloSocio')
                        });
                    });
                    break;
                
                case 'PESSOA':
                    OperacaoService.preAnalisePessoa(
                        {
                            idCategoria: this.dadosDiagnostico.idCategoria,
                            idsTerritorios: this.dadosDiagnostico.territorios.map(p => p.idTerritorio),
                            protocolo: diagnosticoProtocolo.protocolo,
                            nomeRazaoSocial: diagnosticoProtocolo.nome,
                            cpfCnpj: diagnosticoProtocolo.identificador
                        })
                    .then(({data}) => {
                        this.$refs.modalResultadoDiagnostico.abrirModal(data);
                    })
                    .catch(() => {
                        this.$notify.error({
                            message: this.$t('mensagens.operacao.notificacao.erroProtocoloSocio')
                        });
                    });
                    break;
            }
        },

        async realizarDiagnosticoListagem() {
            this.dadosDiagnostico.territorios.forEach(element => {
                if (element.visualizarOperacao) {
                    this.territorios.push({
                        id: element.idTerritorio,
                        geometria: element.geometria
                    });
                    this.diagnosticoPessoa = true;
                }
            });

            await OperacaoService.preAnaliseResumo(this.dadosDiagnostico).then(({ data }) => {
                this.diagnosticosProtocolo = data;
                this.habilitarFinalizarAnalise = true;

            }).catch(() => {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.erroProtocoloSocio')
                });
            });
        },

        fechar() {
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss">
#card-analise-socioambiental-operacao {
    .card-analise-socioambiental-operacao__body {
        gap: 2px;
        display: flex;
        flex-direction: column;
        margin: 20px;

        .card-analise-socioambiental-operacao__body__item {
            height: 75px;
            background-color: var(--white);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: $default-border-radius;
            transition: 0.3s ease-in-out;

            .card-analise-socioambiental-operacao__body__item__icone {
                font-size: 24px;
                margin: 0 15px;
            }

            .card-analise-socioambiental-operacao__body__item--acao {
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 18px;
                margin-right: 20px;
            }

            .alerta {
                color: #df675b;
            }

            .sucesso {
                color: var(--secondary-two);
            }

            .atencao {
                color: #d7bc25;
            }
        }

        .card-analise-socioambiental-operacao__body__item:hover {
            opacity: 0.7;
        }
    }

    .card-analise-socioambiental-operacao__acao {
        display: flex;
        justify-content: space-between;
        margin: 20px;
    }

    .card-analise-socioambiental-operacao__aprovar-recusar {
        background-color: var(--white);
        margin: 20px;
        padding: 20px;
        border-radius: $default-border-radius;
    }

    .campo_obrigatorio::before {
        content: '* ';
        color: red;
    }

    .car-vinculado {
        margin-left: 55px;
    }
}
</style>
